import React from "react";
import PropTypes from "prop-types";

export default class QuoteHelp extends React.Component {
  state = {
    visible: false
  };

  toggle = () => this.setState({ visible: !this.state.visible });

  render() {
    const { visible } = this.state;
    if (!visible) {
      return (
        <div className="text-center" style={{ maxWidth: 600, margin: "0 auto" }}>
          <span onClick={this.toggle} style={{ cursor: "pointer" }}>
            <i className="fa fa-caret-down" /> &nbsp; Show Help
          </span>
        </div>
      );
    }

    return (
      <div className="panel panel-default" style={{ maxWidth: 600, margin: "0 auto" }}>
        <div className="panel-heading text-center">
          <span onClick={this.toggle} style={{ cursor: "pointer" }}>
            <i className="fa fa-caret-up" /> &nbsp; Hide Help
          </span>
        </div>
        <div className="">
          <table className="table">
            <tbody>
              <tr>
                <td>
                  <i className="fa fa-lock" />
                </td>
                <td>
                  Indicates that this group is locked and its contents cannot be modified. It
                  is probably a fixed laboratory suite.
                </td>
              </tr>
              <tr>
                <td>
                  <i className="fa fa-compress" />
                </td>
                <td>
                  Indicates that the contents of this group will be hidden on the final quote
                </td>
              </tr>
              <tr>
                <td>
                  <i className="fa fa-expand" />
                </td>
                <td>
                  Indicates that the contents of this group will be visible on the final quote
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  Click on &nbsp;<i className="fa fa-expand" />&nbsp; or&nbsp;{" "}
                  <i className="fa fa-compress" />&nbsp; to change it
                </td>
              </tr>
              <tr>
                <td>
                  <i className="fa fa-refresh" />
                </td>
                <td>Click to refresh the data in this group</td>
              </tr>
              <tr>
                <td>
                  <i className="fa fa-eye" />
                </td>
                <td>Click to show only this group</td>
              </tr>
              <tr>
                <td>
                  <i className="fa fa-trash" />
                </td>
                <td>Select items to delete</td>
              </tr>
              <tr>
                <td>
                  <i className="fa fa-caret-down" />
                </td>
                <td>Click on the group to show its contents</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
